import type { BankDispensary, MUO } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api/BanksApi';
import { BANK_DISPENSARY_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useBankDispensary(dispensaryId: string) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();

  const {
    data: dispensary,
    isLoading: isLoadingDispensary,
    isError: isDispensaryError
  } = useQuery<MUO | BankDispensary>({
    enabled: !!userBankId.length && !!dispensaryId.length,
    queryKey: [BANK_DISPENSARY_KEY, userBankId, dispensaryId],
    queryFn: () => banksApi.getBankDispensary(userBankId, dispensaryId)
  });

  return { dispensary, isLoadingDispensary, isDispensaryError };
}
